import servicioBase from '@/services/servicio-base'

const servicioBuenFin = {}

servicioBuenFin.clasificaciones =  () => {
    return servicioBase.get('/buen-fin/clasificaciones')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioBuenFin.formasFarmaceuticas =  function(codClasificacion){
    return servicioBase.get(`/buen-fin/formas-farmaceuticas/${codClasificacion}`)
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioBuenFin.buenFin = function(){
    return servicioBase.get('/buen-fin/consultar')
    .then(r => {
        return r.data
    })
    .catch(error => {
        return error
    })
}

servicioBuenFin.buenFinConsultarCantidad = function()
{
   return servicioBase.get('/buen-fin/consultar-cantidad')
   .then(r=>{
      return r.data;
   })
   .catch(e=>{
      return e;
   })
}
export default servicioBuenFin